/** A route that stays inside the Coval app. Protocol-relative URLs are excluded. */
export function isSafeSofiaAppHref(href: string): boolean {
  return href.startsWith("/") && !href.startsWith("//")
}

/** Sofia may render app routes or ordinary HTTP(S) links, but never active URL schemes. */
export function isSafeSofiaHref(href: string): boolean {
  if (isSafeSofiaAppHref(href)) {
    return true
  }
  try {
    const url = new URL(href)
    return url.protocol === "http:" || url.protocol === "https:"
  } catch {
    return false
  }
}
